import React from "react";
import { formatDate } from "../comman/config";

function MainIssueDetailsModal({
    showModal,
    setShowModal,
    issueDetails,
    date,
    ingredient,
    sessionName,
    type,
    selectedDetail
}) {

    if (!showModal) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-11/12 max-w-4xl max-h-[90vh] overflow-y-auto">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-bold">
                        {ingredient}
                        {sessionName && ` (${sessionName})`} on {formatDate(date)}
                    </h2>
                    <button
                        onClick={() => setShowModal(false)}
                        className="text-gray-500 hover:text-gray-700"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                {issueDetails.length === 0 ? (
                    <p className="text-center py-4">No details found.</p>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="w-full text-sm text-left border-collapse border border-gray-300">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                                <tr>
                                    <th className="px-4 py-2 border border-gray-300">Menu Item</th>
                                    <th className="px-4 py-2 border border-gray-300">Kit Numbers</th>
                                    <th className="px-4 py-2 border border-gray-300">{type === 1 ? "Issued Qty" : "Returned Qty"}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {issueDetails.map((issue) => (
                                    <tr key={issue.id} className="border-b hover:bg-gray-50">
                                        <td className="px-4 py-2 border border-gray-300">
                                            {issue.menu_item_name || "-"}
                                        </td>
                                        <td className="px-4 py-2 border border-gray-300">
                                            {issue.kit_numbers
                                                ? issue.kit_numbers ? issue.kit_numbers : "-"
                                                : "-"}
                                        </td>
                                        <td className="px-4 py-2 border border-gray-300">
                                            {type === 1
                                                ? issue.net_issued_qty || "-"
                                                : issue.return_receipt_qty || "-"}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                <div className="flex justify-end mt-4">
                    <button
                        onClick={() => setShowModal(false)}
                        className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
}

export default MainIssueDetailsModal;
